import { TExpiredIndicatorState } from './types';

export function setHasExpiredIndicator(state: TExpiredIndicatorState, value: boolean) {
  state.hasExpiredIndicator = value;
}
